<template>
    <Widget :minWidth="150" :minHeight="200" :maxWidth="250" :maxHeight="600" :title="title">
        <slot />
        <Button @click="$refs.uploader.click()">{{ addLabel }}</Button>
        <input ref="uploader" style="display: none;" type="file" :name="addLabel" @change="addItem" accept="image/*" />
    </Widget>
</template>

<script lang="ts">
import Widget from '@/components/common/widget/Widget.vue';

export default {
    components: {
        Widget: Widget,
    },
    props: {
        addLabel: {
            type: String,
            required: false,
            default: 'Add New',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        addItem: function(event) {
            this.$emit('add-item', event);
        },
    },
};
</script>
